var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.wrapperClasses},[_c('div',{class:_vm.spinnerClasses},[_c('Spin',{attrs:{"fix":""}},[_c('Icon',{class:_vm.iconClasses,attrs:{"type":"load-c","size":"18"}}),_vm._v(" "),(_vm.text)?_c('div',{class:_vm.textClasses},[_vm._v(_vm._s(_vm.text))]):_vm._e()],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bf827d7e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/iview/src/components/scroll/loading-component.vue
// module id = null
// module chunks = 